import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17bb7fa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row items-center gap-2" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgContainer = _resolveComponent("SvgContainer")!
  const _component_VerifyAndAddPhone = _resolveComponent("VerifyAndAddPhone")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openVerify && _ctx.openVerify(...args))),
      class: "flex items-center cursor-pointer gap-2"
    }, [
      _createTextVNode(_toDisplayString(_ctx.fullPhone) + " ", 1),
      (_ctx.phoneLoaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.verfied)
              ? (_openBlock(), _createBlock(_component_SvgContainer, {
                  key: 0,
                  name: "phoneVerified"
                }))
              : (_openBlock(), _createBlock(_component_SvgContainer, {
                  key: 1,
                  name: "phoneNotVerified"
                }))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_SvgContainer, { name: "pencilProfile" })
    ]),
    (_ctx.verify)
      ? (_openBlock(), _createBlock(_component_VerifyAndAddPhone, {
          key: 0,
          initialPhone: _ctx.phone!,
          initialPrefix: _ctx.prefix!,
          hasPhone: _ctx.hasPhone,
          showRemain: false,
          open: _ctx.showPhonePopup,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPhonePopup = false)),
          onNewPhone: _ctx.handleNewPhone
        }, null, 8, ["initialPhone", "initialPrefix", "hasPhone", "open", "onNewPhone"]))
      : _createCommentVNode("", true)
  ]))
}